// extracted by mini-css-extract-plugin
export var avatar = "comment-item-module--avatar--ByMih";
export var comment = "comment-item-module--comment--YfiRW";
export var commentBox = "comment-item-module--comment-box--wwGNg";
export var content = "comment-item-module--content--MrpMG";
export var date = "comment-item-module--date--h9gRc";
export var moveIn = "comment-item-module--move-in--mqboW";
export var name = "comment-item-module--name--FuRMw";
export var separator = "comment-item-module--separator--5kPu3";